import { render, staticRenderFns } from "./ModalFiles.vue?vue&type=template&id=71c9ea76&"
import script from "./ModalFiles.vue?vue&type=script&lang=js&"
export * from "./ModalFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports